require('animation.gsap')

const ScrollMagic = require('ScrollMagic')
const TimelineLite = require('TimelineLite')

const splitScroll = {
  bottle_hover: (container, center, left, right) => {
    left.addEventListener('mouseenter', (e) => {
      container.classList.add(`bg-${e.target.dataset.colour}`)
    })

    left.addEventListener('mouseleave', (e) => {
      container.classList.remove(`bg-${e.target.dataset.colour}`)
    })

    center.addEventListener('mouseenter', (e) => {
      container.classList.add(`bg-${e.target.dataset.colour}`)
    })

    center.addEventListener('mouseleave', (e) => {
      container.classList.remove(`bg-${e.target.dataset.colour}`)
    })

    right.addEventListener('mouseenter', (e) => {
      container.classList.add(`bg-${e.target.dataset.colour}`)
    })

    right.addEventListener('mouseleave', (e) => {
      container.classList.remove(`bg-${e.target.dataset.colour}`)
    })
  },

  create: ({
    centerBox,
    centerImg,
    centerShadow,
    container,
    leftBox,
    leftImg,
    leftShadow,
    rightBox,
    rightImg,
    rightShadow,
  }) => {
    // init controller
    splitScroll.instance.controller = new ScrollMagic.Controller()

    // scene 1
    // this timeline needs reset on load to stop initiating partially through
    // scene!
    const t1 = new TimelineLite()
      .fromTo(
        leftImg,
        1,
        { xPercent: 1, yPercent: -16, width: 300, translateZ: 0 },
        { xPercent: 1, yPercent: -1, width: 170, translateZ: 0 },
        0,
      )
      .fromTo(
        centerImg,
        1,
        { xPercent: 0, yPercent: -20, width: 300, translateZ: 0 },
        { xPercent: 0, yPercent: -1, width: 170, translateZ: 0 },
        0,
      )
      .fromTo(
        rightImg,
        1,
        { xPercent: 1, yPercent: -16, width: 300, translateZ: 0 },
        { xPercent: 1, yPercent: -1, width: 170, translateZ: 0 },
        0,
      )
      .fromTo(leftBox,
        1,
        { xPercent: 50, translateZ: 0 },
        { xPercent: -50, translateZ: 0 },
        0,
      )
      .fromTo(rightBox,
        1,
        { xPercent: -50, translateZ: 0 },
        { xPercent: 50, translateZ: 0 },
        0,
      )

    new ScrollMagic.Scene({
      duration: document.querySelector('[data-step="1"]').offsetHeight,
      triggerElement: '[data-step="1"]',
    })
      .setTween(t1)
      .addTo(splitScroll.instance.controller)

    setTimeout(() => {
      t1.play(0.001)
      t1.play(0)
    }, 300)

    // scene 2
    new ScrollMagic.Scene({
      duration: document.querySelector('[data-step="2"]').offsetHeight,
      triggerElement: '[data-step="2"]',
    })
      .setTween(
        new TimelineLite({
          onUpdate() {
            if (this.timeline.progress() === 0) {
              container.classList.remove('c-split-scroll--fixed')
            } else {
              container.classList.add('c-split-scroll--fixed')
            }
          },
        })
          .fromTo(centerShadow, 1, { opacity: 0, translateZ: 0 }, { opacity: 1, translateZ: 0 }, 0)
          .fromTo(leftBox, 1, { xPercent: -50, translateZ: 0 }, { xPercent: -100, translateZ: 0 }, 0)
          .fromTo(leftShadow, 1, { opacity: 0, translateZ: 0 }, { opacity: 1, translateZ: 0 }, 0)
          .fromTo(rightBox, 1, { xPercent: 50, translateZ: 0 }, { xPercent: 100, translateZ: 0 }, 0)
          .fromTo(rightShadow, 1, { opacity: 0, translateZ: 0 }, { opacity: 1, translateZ: 0 }, 0)
      )
      .addTo(splitScroll.instance.controller)

    // scene 3
    new ScrollMagic.Scene({
      duration: document.querySelector('[data-step="3"]').offsetHeight,
      triggerElement: '[data-step="3"]',
    })
      .setTween(
        new TimelineLite({
          onUpdate() {
            if (this.timeline.progress() === 0) {
              container.classList.add('c-split-scroll--fixed')
              container.classList.remove('c-split-scroll--bottom')
            } else {
              container.classList.add('c-split-scroll--bottom')
              container.classList.remove('c-split-scroll--fixed')
            }
          },
        }).to('.c-split-scroll', 1, { top: 0 }, 0),
      )
      .addTo(splitScroll.instance.controller)
  },

  destroy: (...elements) => {
    splitScroll.instance.controller.destroy(true)
    splitScroll.instance.controller = false

    elements.map((e) => {
      e.style.opacity = ''
      e.style.transform = ''
      e.style.width = ''

      return true
    })
  },

  enable: () => {
    // if small screen, do nothing
    if (window.innerWidth < 769) {
      return
    }

    // store elements
    const bottom = document.querySelector('.c-split-scroll__copy-bottom')
    const container = document.querySelector('.c-split-scroll')

    const detailsLeft = document.querySelector(
      '.c-split-scroll__item--left .c-split-scroll__details',
    )
    const detailsCenter = document.querySelector(
      '.c-split-scroll__item--center .c-split-scroll__details',
    )
    const detailsRight = document.querySelector(
      '.c-split-scroll__item--right .c-split-scroll__details',
    )

    const centerBox = document.querySelector('.c-split-scroll__item--center')
    const centerImg = document.querySelector('.c-split-scroll__item--center .c-split-scroll__image')
    const centerShadow = document.querySelector(
      '.c-split-scroll__item--center .c-split-scroll__bottle-shadow',
    )

    const leftBox = document.querySelector('.c-split-scroll__item--left')
    const leftImg = document.querySelector('.c-split-scroll__item--left .c-split-scroll__image')
    const leftShadow = document.querySelector(
      '.c-split-scroll__item--left .c-split-scroll__bottle-shadow',
    )

    const rightBox = document.querySelector('.c-split-scroll__item--right')
    const rightImg = document.querySelector('.c-split-scroll__item--right .c-split-scroll__image')
    const rightShadow = document.querySelector(
      '.c-split-scroll__item--right .c-split-scroll__bottle-shadow',
    )

    const top = document.querySelector('.c-split-scroll__copy-top')

    // initialise bottle hover interaction
    splitScroll.bottle_hover(document.body, centerBox, leftBox, rightBox)

    // create scenes
    splitScroll.create({
      centerBox,
      centerImg,
      centerShadow,
      container,
      detailsCenter,
      detailsLeft,
      detailsRight,
      leftBox,
      leftImg,
      leftShadow,
      rightBox,
      rightImg,
      rightShadow,
    })

    // resize handler
    window.addEventListener('resize', () => {
      // if below tablet, destroy scroller & reset element styles
      // else update scroller metrics or create scroller
      if (window.innerWidth < 769) {
        if (splitScroll.instance.controller) {
          splitScroll.destroy({
            centerBox,
            centerImg,
            centerShadow,
            container,
            detailsCenter,
            detailsLeft,
            detailsRight,
            leftBox,
            leftImg,
            leftShadow,
            rightBox,
            rightImg,
            rightShadow,
          })
        }
      } else if (splitScroll.instance.controller) {
        splitScroll.instance.controller.update(true)
      } else {
        splitScroll.create({
          centerBox,
          centerImg,
          centerShadow,
          container,
          detailsCenter,
          detailsLeft,
          detailsRight,
          leftBox,
          leftImg,
          leftShadow,
          rightBox,
          rightImg,
          rightShadow,
        })
      }
    })
  },

  instance: {
    controller: false,
  },
}

export default { enable: splitScroll.enable }
